import { Group } from '@mantine/core';

type TabsListActionsProps = {
  children: React.ReactNode;
};

export const TabsListActions: React.FC<TabsListActionsProps> = ({
  children,
}) => {
  return (
    <Group flex="1" justify="flex-end" mt="5px">
      {children}
    </Group>
  );
};
